import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';

export default function ConectividadeLogistica() {
  const { watch } = useFormContext();
  
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre conectividade e logística do município, incluindo transporte e infraestrutura digital.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="modal_predominante"
          label="Modal predominante da rede de transporte intermunicipal"
          placeholder="Digite o modal predominante"
          helpText="Ex: rodoviário, ferroviário, hidroviário, etc."
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="rodovias_condicao"
          label="Condição das rodovias (% em bom estado)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem das rodovias em bom estado de conservação"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
        
        <FormField
          name="internet_cobertura"
          label="Cobertura de internet banda larga (%)"
          type="percent"
          placeholder="Digite a porcentagem"
          helpText="Porcentagem da população com acesso à internet banda larga"
          validation={{
            min: {
              value: 0,
              message: 'O valor deve ser maior ou igual a 0',
            },
            max: {
              value: 100,
              message: 'O valor deve ser menor ou igual a 100',
            },
          }}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <FormField
          name="centros_logisticos_quantidade"
          label="Quantidade de centros logísticos e armazéns"
          type="numeric"
          thousandSeparator="."
          decimalSeparator=","
          placeholder="Digite a quantidade"
          helpText="Número total de centros logísticos e armazéns"
        />
        
        <FormField
          name="centros_logisticos_localizacao"
          label="Localização dos centros logísticos"
          placeholder="Digite a localização dos centros logísticos"
          helpText="Principais áreas onde estão localizados os centros logísticos"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao4"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao4"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
